import { useTranslation } from 'react-i18next';

export default function Testimonials() {
  const { t } = useTranslation();
  const testimonials = [
    {
      text: t('testimonial1Text'),
      name: 'Hans Petter',
      role: t('testimonial1Role'),
      initials: 'HP',
      avatarBg: '#EADFD2',
      avatarFg: '#8C5A2E',
    },
    {
      text: t('testimonial2Text'),
      name: 'Erik Larsen',
      role: t('testimonial2Role'),
      initials: 'EL',
      avatarBg: '#E4EFE0',
      avatarFg: '#4A7A54',
    },
  ]

  return (
    <section id="testimonials" className="mx-auto max-w-[1152px] px-6 py-24 sm:py-28 lg:px-16">
      <div className="flex flex-col gap-12">
        <div className="flex flex-col items-center gap-3.5 text-center">
          <h2 className="text-4xl font-bold tracking-[-1px] text-ink">{t("testimonialsTitle")}</h2>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {testimonials.map((q, i) => (
            <div key={i} className="flex flex-col gap-[22px] rounded-4xl bg-surface p-9 shadow-card">
              <span className="font-serif text-[52px] leading-[0.5] text-[#FF9900]">&ldquo;</span>
              <p className="text-[17px] leading-relaxed text-ink_soft">{q.text}</p>
              <div className="mt-auto flex items-center gap-3">
                <div
                  className="flex h-[42px] w-[42px] items-center justify-center rounded-full text-sm font-bold"
                  style={{ background: q.avatarBg, color: q.avatarFg }}
                >
                  {q.initials}
                </div>
                <div className="flex flex-col">
                  <span className="text-sm font-bold text-ink">{q.name}</span>
                  <span className="text-xs font-medium text-muted">{q.role}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div
          className="trustpilot-widget flex justify-center"
          data-locale="en-GB"
          data-template-id="5419b6a8b0d04a076446a9ad"
          data-businessunit-id="6431713917cc990a6d1b67ae"
          data-style-height="24px"
          data-style-width="100%"
          data-theme="light"
          data-min-review-count="10"
          data-without-reviews-preferred-string-id="3"
          data-style-alignment="center"
        >
          <a
            href="https://uk.trustpilot.com/review/klassekartgenerator.no"
            target="_blank"
            rel="noreferrer"
            className="text-[13px] font-medium text-muted hover:text-ink"
          >
            Trustpilot
          </a>
        </div>
      </div>
    </section>
  )
}
